<template>
  <div class="content">
    <div ref="charts" style="width: 700px; height: 625px"></div>
  </div>
</template>


<script>
import * as echarts from "echarts";
// import { mapData } from '@/api/map';

// import mapData from "@/common/map/guangzhou.json";
export default {
  props: {
    cdata: [],
    Region: {}
  },
  data() {
    return {
      mapData: {},
      qnv: [],
    }
  },
  created() {
    this.init()

  },
  methods: {
    async init() {
      this.mapData = JSON.parse(this.Region)
      console.log('cdata', this.cdata)

      this.$nextTick(() => {
        this.initCharts();
      })
    },

    // 匹配区号
    match(name) {
      for (let index = 0; index < this.cdata.length; index++) {
        const element = this.cdata[index];
        if(element.name == name) {
          return element.value[2]
        }
      }
    },

    initCharts() {
      let that = this
      const charts = echarts.init(this.$refs["charts"]);

      // const option = {
      //   //   // 提示浮窗样式
      //   tooltip: {
      //     show: true,
      //     trigger: "item",
      //     alwaysShowContent: false,
      //     backgroundColor: "#0C121C",
      //     borderColor: "rgba(0, 0, 0, 0.16);",
      //     hideDelay: 100,
      //     triggerOn: "mousemove",
      //     enterable: true,
      //     textStyle: {
      //       color: "#DADADA",
      //       fontSize: "12",
      //       width: 20,
      //       height: 30,
      //       overflow: "break",
      //     },
      //     showDelay: 100,
      //     formatter: function (params) {
      //       console.log(params)
      //       // return `<div style="border-radius: 5px; font-weight: 600;color:#fff;padding:5px 10px;">${params.data.num}</div>`;
      //       // return `地区：${params.name}</br>数值：${params.value[2]}`;
      //     },
      //   },
      //   // 主地图配置
      //   geo: {
      //     map: 'map',
      //     roam: true,
      //     zoom: 1.2,
      //     center: [105, 38],
      //     itemStyle: {
      //       normal: {
      //         areaColor: '#3978b5',
      //         borderColor: '#179dbd',
      //         borderWidth: 1
      //       },
      //       emphasis: {
      //         areaColor: '#179dbd'
      //       }
      //     },
      //     label: {
      //       show: true,
      //       normal: {
      //         show: true,
      //         fontSize: '14',
      //         color: '#fff'
      //       },
      //       formatter: function (params) {
      //         // 查找对应省份的数据
      //         console.log(params);
      //         this.cdata.find(item => {
      //           console.log(item);
      //         });
      //         // return params.name;
      //       },
      //       color: '#333',
      //       fontSize: 12,
      //       rich: {
      //         name: {
      //           fontSize: 12,
      //           fontWeight: 'bold'
      //         },
      //         value: {
      //           fontSize: 10,
      //           color: '#666'
      //         }
      //       }
      //     },
      //     // // 显示南海小图
      //     // showSouthChinaSea: true,
      //     // southChinaSeaScale: 1.2,
      //     // southChinaSeaBorderColor: '#404a59',
      //     // southChinaSeaBorderWidth: 1,
      //     // southChinaSeaBackgroundColor: '#e0e0e0'
      //   },
      //   series: [{
      //     type: 'scatter',
      //     coordinateSystem: 'geo',
      //     symbol: 'circle',
      //     symbolSize: 10,
      //     color: "#37a2da",
      //     data: this.cdata
      //   }],
      // };



      const option = {
        backgroundColor: "rgba(0,0,0, 0)",
        geo: {
          map: "map",
          roam: true,
          zoom: 1,
          label: {
            normal: {
              show: true,
              textStyle: {
                color: "#fff",
                fontSize: 14,
              },
              // 修改formatter函数，使区名下方显示数值
              formatter: function (params) {
                // params.value可以是数组或数值，根据实际数据结构调整
                let value = that.match(params.name) || 0
                // 使用\n添加换行符，使数值显示在区名下方
                return `${params.name}\n${value}`;
              }
            },
            emphasis: {
              textStyle: {
                color: "#fff",
              }
            },
          },
          itemStyle: {
            normal: {
              borderColor: "rgba(147, 235, 248, 1)",
              borderWidth: 1,
              areaColor: {
                type: "radial",
                x: 0.5,
                y: 0.5,
                r: 0.8,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(21, 84, 174, 0)",
                  },
                  {
                    offset: 1,
                    color: "rgba(21, 167, 189, .2)",
                  },
                ],
                globalCoord: false,
              },
              shadowColor: "rgba(128, 217, 248, 1)",
              shadowOffsetX: -2,
              shadowOffsetY: 2,
              shadowBlur: 10,
            },
            emphasis: {
              areaColor: "#389BB7",
              borderWidth: 0,
            },
          },
        },
      };
      // 地图注册，第一个参数的名字必须和option.geo.map一致
      echarts.registerMap("map", this.mapData)

      charts.setOption(option);
    },
  },
};
</script>
